<button class="close float-right" matDialogClose>&times;</button>
<h2 mat-dialog-title>Mensagem</h2>
<mat-dialog-content class="mat-typography">
    <div mat-dialog-content class="mat-typography" style="max-height: 100%;">
        <div class="row">
            <p style="padding-left: 20px">{{ data }}</p>
        </div>
    </div>
</mat-dialog-content>
